import EditorialLayout, { editorialStyles as styles } from '../../components/EditorialLayout'

export default function Guides() {
  return (
    <EditorialLayout
      title='Instrument Tuning Guides'
      description='Understand guitar frequencies, learn how an online tuner detects pitch, and solve the most common reasons an instrument will not stay in tune.'
      path='/guides'
      eyebrow='Learning library'
    >
      <p>
        These guides explain the measurements behind the tuner and turn them
        into practical steps. Start with the frequency chart if you need a
        reference, the tuner guide if you want to understand pitch detection,
        or the troubleshooting guide if your guitar will not hold its tuning.
      </p>

      <div className={styles.cards}>
        <section className={styles.guideCard}>
          <h2>Guitar String Frequency Chart</h2>
          <p>
            Standard tuning notes, octaves, exact frequencies, and examples of
            what a slightly flat or sharp reading means.
          </p>
          <a href='/guides/guitar-string-frequency-chart'>Read the frequency guide →</a>
        </section>
        <section className={styles.guideCard}>
          <h2>How an Online Tuner Works</h2>
          <p>
            Follow the signal from your microphone through pitch detection to
            the note and tuning direction shown on screen.
          </p>
          <a href='/guides/how-online-guitar-tuner-works'>See how pitch detection works →</a>
        </section>
        <section className={styles.guideCard}>
          <h2>Why Guitars Go Out of Tune</h2>
          <p>
            Diagnose fresh strings, slipping windings, nut friction, temperature
            changes, tremolo movement, and intonation problems.
          </p>
          <a href='/guides/why-guitar-goes-out-of-tune'>Troubleshoot your guitar →</a>
        </section>
      </div>

      <div className={styles.callout}>
        <p>
          All frequency values in these guides assume twelve-tone equal
          temperament and concert pitch A4 = 440 Hz unless stated otherwise.
        </p>
      </div>
    </EditorialLayout>
  )
}
